module.exports = "./img/05f0b94386309193361db850afcf6829.jpg";